import DateEditorForDateRange from './DateEditorForDateRange';
import TotalContractValue from './TotalContractValue';

export const editors = {
  'urn:replicon:script-key:parameter:contract-start-date': DateEditorForDateRange,
  'urn:replicon:script-key:parameter:contract-end-date': DateEditorForDateRange,
  'urn:replicon:script-key:parameter:total-contract-value-in-reference-currency': TotalContractValue
};
